namespace $.$$ {
	export class $shm_hitalama_components_tests_detail extends $.$shm_hitalama_components_tests_detail {
		content_rows() {
			return [ this.Summary(), ...( this.run_total() ? [ this.Runs(), ...( this.run_total() > ( this.Run_pages() as $shm_paginator ).size() ? [ this.Run_pages() ] : [] ), this.Result_status(), this.Report() ] : [ this.Empty() ] ) ]
		}
		@ $mol_mem
		selected_run( next?: string ) { this.definition(); this.selected(); return next ?? this.run_ids()[0] ?? '' }
		title() { return this.$.$shm_hitalama_components_scenario.validate( this.baseline() ).title }
		summary() {
			const spec = this.$.$shm_hitalama_components_scenario.validate( this.baseline() )
			const actions = { expect: 'Проверить', click: 'Нажать', fill: 'Заполнить', scroll: 'Прокрутить', screenshot: 'Посмотреть снимок' }
			const steps = spec.steps.map( ( step, index ) => `${ index + 1 }. ${ step.label || actions[step.action] + ( step.text || step.name || step.selector ? ': ' + ( step.text || step.name || step.selector ) : '' ) }` )
			return steps.join( '\n' )
		}
		scenario() {
			if( !this.selected() ) return null
			const scenario = this.definition().Test_scenarios()?.key( this.selected() )?.remote()
			if( scenario ) this.$.$shm_hitalama_map_component_ready.read( scenario )
			return scenario
		}
		@ $mol_mem
		baseline() { return this.scenario()?.Spec()?.val() ?? '' }
		run_options() {
			const pager = this.Run_pages() as $shm_paginator, start = pager.current() * pager.size()
			return { '': 'Выберите прогон', ...Object.fromEntries( this.run_ids().slice( start, start + pager.size() ).map( id => {
				const run = this.scenario()!.Runs()!.key( id )?.remote()
				if( !run ) return [ id, id ]
				this.$.$shm_hitalama_map_component_ready.read( run )
				const data = JSON.parse( run.Data()?.val() || '{}' )
				return [ id, `${ this.date( data.started || data.queued ) } — ${ this.state_label( data.status ) }` ]
			} ) ) }
		}
		// Native dictionary order is newest-first; reversing it showed the oldest run first.
		run_ids() { return ( this.scenario()?.Runs()?.keys() ?? [] ).map( String ) }
		run_total() { return this.run_ids().length }
		// Override the generated channel to reset it when switching scenarios.
		@ $mol_mem
		run_page( next?: number ) {
			this.definition(); this.selected()
			if( next !== undefined ) this.selected_run( '' )
			return next ?? 0
		}
		current_run() {
			if( !this.selected_run() ) return null
			const run = this.scenario()?.Runs()?.key( this.selected_run() )?.remote()
			if( run ) this.$.$shm_hitalama_map_component_ready.read( run )
			return run
		}
		data() {
			const data = JSON.parse( this.current_run()?.Data()?.val() || '{}' )
			if( data.runner === 'playwright' && data.status === 'running' && this.$.$mol_state_time.now( 1000 ) - Date.parse( data.started ) > 95000 ) return { ...data, status: 'interrupted', error: 'Исполнитель не завершил прогон за отведённое время. Старые действия автоматически не повторяются.' }
			return data
		}
		state_label( status: string ) { return { queued: 'В очереди', running: 'Выполняется', passed: 'Пройден', failed: 'Ошибка', interrupted: 'Прерван', stale: 'Код изменился', review: 'Требуется визуальная проверка' }[status] || status || '' }
		status_label() { return this.state_label( this.data().status ) }
		status_kind() {
			const kinds: Record<string, string> = { passed: 'success', failed: 'error', queued: 'active', running: 'active', review: 'active' }
			return kinds[ this.data().status ] || ''
		}
		date( value: string ) {
			if( !value ) return ''
			const date = new Date( value )
			if( !Number.isFinite( date.getTime() ) ) return ''
			const iso = `${ date.getFullYear() }-${ String( date.getMonth() + 1 ).padStart( 2, '0' ) }-${ String( date.getDate() ).padStart( 2, '0' ) }`
			return this.$.$shm_date.text( iso ) + ' ' + date.toLocaleTimeString( 'ru-RU', { hour12: false } )
		}
		report() {
			if( !this.current_run() ) return 'Прогон не выбран'
			const data = this.data()
			return [ `Исполнитель: ${ data.runner || 'браузер клиента (старый формат)' }`, `Начало: ${ this.date( data.started || data.queued ) }`, data.finished && `Конец: ${ this.date( data.finished ) }`, `Код: ${ data.source_hash || 'не указан' }`, data.error || '', ...( data.steps || [] ).map( ( step: any )=> `Шаг ${ step.index + 1 } — ${ step.label || step.action }: ${ step.status } (${ step.ms } мс)${ step.error ? '\n' + step.error : '' }${ step.visual ? '\nСнимок не сохранён. Автоматическая визуальная проверка не выполнялась.' : '' }` ) ].filter( Boolean ).join( '\n\n' )
		}
	}
}
